import React from 'react';
import { connect } from 'react-redux';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import { columnUsers, hasColumn } from '@/constants/fields';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleUserGroupsSelected } from '../actions/usergroups/read';

const UserGroupsTableColumns = ({
  category,
  columns,
  items,
  onCheckBoxClick,
}) => (
  <NameDescriptionColumns
    entity="usergroup"
    columns={columns}
    items={items}
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
  >
    {hasColumn(columns, columnUsers) && (<UnsortedColumn columnId={columnUsers} />)}
  </NameDescriptionColumns>
);

const mapDispatchToProps = ({
  onCheckBoxClick: toggleUserGroupsSelected,
});

export default connect(undefined, mapDispatchToProps)(UserGroupsTableColumns);
